/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import downloadIcon from "dc-icons/consumption/s_download_18.svg";
import downloadIconLight from "dc-icons/consumption/s_download_light_18.svg";
import { onDownloadFileClick } from "components/topbar/actions/downloadFile";
import { getIsInPlaceMode } from "selectors/viewModeSelectors";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import * as constants from "constants/constants";

const mapStoreToProps = (stores, ownProps) => ({
  icon: ownProps.options.color === "light" ? downloadIcon : downloadIconLight,
  clickHandler: () => {
    onDownloadFileClick(stores, {
      triggeredFrom: "reusableDownloadComponent"
    });
  },
  ariaLabel: "arialabel.download",
  tooltipString: "tooltip.download",
  tooltipPlacement: getIsInPlaceMode(stores) ? constants.TOOLTIP_TOP_PLACEMENT : constants.TOOLTIP_BOTTOM_PLACEMENT,
  tooltipDelay: constants.TOOLTIP_DELAY
});
const DownloadButtonContainer = inject(mapStoreToProps)(ButtonWrapper);

DownloadButtonContainer.defaultProps = {
  options: {
    color: "light"
  }
};

export { DownloadButtonContainer };
